import MapPopupController from '../thing-details/thing-location/map-popup/map-popup.controller';

const MapPopupTemplate = require('../thing-details/thing-location/map-popup/map-popup.html');

export default class ThingsListController {
    /** @ngInject */
    constructor(EventEmitter, DialogService, GeoService) {
        this.eventEmitter = EventEmitter;
        this.DialogService = DialogService;
        this.GeoService = GeoService;
    }

    $onInit() {
        this.order = '';
        this.selected = [];
        this.allSelected = false;
        this.showSelectAllHint = false;
        this.orderCounter = {};
        this.defaultCoordinates = this.GeoService.getCoordsByKey('default') || {};

        this.onReorderBinded = this.onReorder.bind(this);
        this.onListItemSelectedBinded = this.onListItemSelected.bind(this);
        this.onListItemUnselectedBinded = this.onListItemUnselected.bind(this);
    }

    showLocation(ev, location) {
        let marker;
        let centerCoordinates;

        if (location) {
            centerCoordinates = {
                lat: location.latitude,
                lng: location.longitude,
                address: location.address
            };

            marker = centerCoordinates;
        } else {
            centerCoordinates = {
                lat: this.defaultCoordinates.lat,
                lng: this.defaultCoordinates.lng
            };
        }

        this.DialogService.show({
            controller: MapPopupController,
            template: MapPopupTemplate,
            controllerAs: '$ctrl',
            parent: document.body,
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true,
            locals: {
                marker,
                centerCoordinates,
                updateMarker: null,
                isEditing: false
            }
        });
    }

    hasLocation(location) { // eslint-disable-line class-methods-use-this
        return (location && location.latitude && location.longitude);
    }

    onReorder(order) {
        this.onListReorder({
            order
        });
    }

    onChangeThingStarred({ starred }, thing) {
        this.onThingStarred(
            this.eventEmitter({
                thing: {
                    id: thing.id,
                    starred
                }
            })
        );
    }

    onListItemSelected() {
        if (this.things.length === this.selected.length) {
            this.showSelectAllHint = true;
        }
        this.prepareSelectedThings(this.allSelected);
    }

    onListItemUnselected() {
        this.hideSelectAllHint();
        this.toggleAllSelected(false);
    }

    hideSelectAllHint() {
        this.showSelectAllHint = false;
    }

    toggleAllSelected(state) {
        this.allSelected = state;
        this.prepareSelectedThings(this.allSelected);
    }

    prepareSelectedThings(isQuery) {
        this.selectedThings.isQuery = isQuery;
        this.selectedThings.list = this.selected;
        this.selectedThings.totalSelected = isQuery ? this.metadata.total : this.selected.length;
    }

    onThingSelect(thing) {
        this.onSelectThing(
            this.eventEmitter({
                thing
            })
        );
    }

    // TODO: Dirty check - we must refactor this
    isThingSelected(thing) {
        return null !== this.selectedThing && this.selectedThing === thing;
    }

    getThings() {
        return this.things;
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/things-list/things-list.controller.js